function print(elm) {
  let mywindow = window.open("", "PRINT");

  mywindow.document.write("<html><head><title>" + document.title + "</title>");
  mywindow.document.write(
    `<style>
      @page { size: portrait; }
      * {font-family: 'Arial', sans-serif;}
      .event-list__event {border-bottom: 1px solid grey; padding-bottom: 10px;}
      .event-list__event--leading {border-bottom: none;}
      .event-list__event h3 {margin-bottom: 10px;}
      .calendar__event-list__leading__container {padding: 10px; background: #ededed;}
      .calendar__event-list__leading__container h2 {margin-top: 0;}
    </style>`
  );
  mywindow.document.write("</head><body >");
  mywindow.document.write("<h1>" + document.title + "</h1>");
  mywindow.document.write(elm.innerHTML);
  mywindow.document.write("</body></html>");

  mywindow.document.close(); // necessary for IE >= 10
  mywindow.focus(); // necessary for IE >= 10*/

  mywindow.print();
  // mywindow.close();

  return true;
}

if (
  document.querySelector(".calendar__event-list") &&
  document.querySelector(".btn-action--print")
) {
  const calendar = document.querySelector(".calendar__event-list");
  const printBtn = document.querySelector(".btn-action--print");

  printBtn.addEventListener("click", (e) => {
    e.preventDefault();
    print(calendar);
  });
}
